import {useCallback} from "react"
import useDispatch from "hooks/useDispatch"

export const useLoadPeriods = () => {
  const dispatch = useDispatch()
  return useCallback((envId: number) => dispatch.periods.loadPeriods({environment: {id: envId}}), [dispatch.periods])
}